import React, { useState } from 'react';
import { Card, Button, Space, Tag } from 'antd';
import { DVIInspectionFull } from '../../types/dvi';

export interface DVISummaryCardProps {
  inspection: DVIInspectionFull;
}

export const DVISummaryCard: React.FC<DVISummaryCardProps> = ({ inspection }) => {
  const [expanded, setExpanded] = useState(false);
  const counts = inspection.items.reduce(
    (acc, i) => {
      if (i.status === 'pass') acc.pass++;
      else if (i.status === 'attention') acc.attention++;
      else if (i.status === 'fail') acc.fail++;
      return acc;
    },
    { pass: 0, attention: 0, fail: 0 },
  );
  const dateStr = inspection.completed_at
    ? new Date(inspection.completed_at).toLocaleString()
    : '';

  // Group items by category for full report
  const byCategory = new Map<string, typeof inspection.items>();
  for (const it of inspection.items) {
    const list = byCategory.get(it.category_name) ?? [];
    list.push(it);
    byCategory.set(it.category_name, list);
  }

  return (
    <Card title="Completed Inspection" extra={<Tag color="green">Completed</Tag>}>
      <Space direction="vertical" style={{ width: '100%' }}>
        <div style={{ color: '#666', fontSize: 13 }}>Completed on {dateStr}</div>
        <Space>
          <Tag color="green">✓ {counts.pass} Passed</Tag>
          <Tag color="gold">⚠ {counts.attention} Attention</Tag>
          <Tag color="red">✗ {counts.fail} Failed</Tag>
        </Space>
        {inspection.summary_notes && (
          <blockquote style={{
            margin: 0, padding: '4px 12px',
            borderLeft: '3px solid #ccc', color: '#444', fontStyle: 'italic',
          }}>{inspection.summary_notes}</blockquote>
        )}
        <Button onClick={() => setExpanded(e => !e)}>
          {expanded ? 'Hide full report' : 'View full report'}
        </Button>
        {expanded && Array.from(byCategory.entries()).map(([catName, items]) => (
          <div key={catName} style={{ marginTop: 8 }}>
            <h4 style={{ margin: 0, fontSize: 13, textTransform: 'uppercase' }}>{catName}</h4>
            {items.map(it => (
              <div key={it.id} style={{ marginLeft: 12, fontSize: 13 }}>
                {it.status === 'pass' ? '✓' : it.status === 'attention' ? '⚠' : '✗'}{' '}
                {it.point_name}
                {it.notes && <span style={{ color: '#888' }}> — {it.notes}</span>}
              </div>
            ))}
          </div>
        ))}
      </Space>
    </Card>
  );
};

export default DVISummaryCard;
